export enum WellKnownLocations {
    aus = 1,
    all = 99,
}
